/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrInputGroupModule } from "igniteui-react-inputs";
import { IgrDataGridCoreModule } from './igr-data-grid-core-module';
import { IgrNumericColumnModule } from './igr-numeric-column-module';
import { IgrDateTimeColumnModule } from './igr-date-time-column-module';
import { IgrImageColumnModule } from './igr-image-column-module';
import { IgrTextColumnModule } from './igr-text-column-module';
import { IgrMultiColumnComboBox } from './igr-multi-column-combo-box';
import { MultiColumnComboBox } from './MultiColumnComboBox';
import { TypeRegistrar } from "igniteui-react-core";
var IgrMultiColumnComboBoxModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrMultiColumnComboBoxModule() {
    }
    IgrMultiColumnComboBoxModule.register = function () {
        IgrInputGroupModule.register();
        IgrDataGridCoreModule.register();
        IgrNumericColumnModule.register();
        IgrDateTimeColumnModule.register();
        IgrImageColumnModule.register();
        IgrTextColumnModule.register();
        TypeRegistrar.registerCons('IgrMultiColumnComboBox', IgrMultiColumnComboBox);
        TypeRegistrar.registerCons('IgrMultiColumnComboBox', IgrMultiColumnComboBox);
        TypeRegistrar.register('MultiColumnComboBox', MultiColumnComboBox.$type);
    };
    return IgrMultiColumnComboBoxModule;
}());
export { IgrMultiColumnComboBoxModule };
//# sourceMappingURL=igr-multi-column-combo-box-module.js.map
